import React, { useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import UserApi from "../common/Apis/UserApi";
import { Button, DatePicker, Form, Input, notification, Steps } from "antd";
import { Typography } from "antd";
import "../Protective/Protective.css";
import { CheckCircleFilled } from "@ant-design/icons";

import TextArea from "antd/es/input/TextArea";
import moment from "moment";
import FooterRegistraion from "../common/FooterDashboard/FooterRegistraion";
const { Title } = Typography;
const Protective = (props) => {
  const { placement } = "topRight";
  let navigate = useNavigate();
  const currentDate = moment();
  const [api, contextHolder] = notification.useNotification();

  // Get User Token and Email
  const token = localStorage.getItem("userToken");
  const userEmail = localStorage.getItem("userEmail");
  // Update Aptitude Test Status Function

  const updateAptitudeTestStatus = useCallback(() => {
    const formData = new FormData();
    formData.append("email", userEmail);
    formData.append(`aptitudeTestStatus`, "PROTECTIVE_CLOTHING");

    UserApi.updateAptitudeTestStatus(formData).catch((err) => {
      // Error Notification
      console.log(err);
      if (err) {
        api.error({
          message: `${err}`,
          placement,
        });
      }
    });
  }, [api, userEmail]);

  const tokenVerification = useCallback(() => {
    UserApi.tokenVerification(token)
      .then((response) => {
        localStorage.setItem("testPriority", 1);
        updateAptitudeTestStatus();
      })
      .catch((err) => {
        if (err.success === false) {
          return navigate("/");
        }
      });
  }, [updateAptitudeTestStatus, navigate, token]);

  useEffect(() => {
    tokenVerification();
    // Page onLoad Scroll Top
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [tokenVerification]);

  const handleSubmit = (data) => {
    console.log(data?.personName);
    let formData = JSON.stringify({
      name: data?.personName,
      roleName: data?.personRole,
      guideline: data?.guideline,
      email: userEmail,
    });
    UserApi.ProtectiveClothing(formData)
      .then((response) => {
        return navigate("/questionnaire");
      })
      .catch((err) => {
        console.log(err);
        // Error Notification
        if (err.apiError.status) {
          notification.open({
            message: (
              <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>
            ),
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
    // return navigate("/questionnaire");
  };

  // Registration  Steps
  const items = [
    {
      description: (
        <>
          <div className="stepsLayout">
            <p className="step">Step 1</p>
            <h4>
              <b>Induction</b>
            </h4>
            <p className="Compleletd">Compleletd</p>
          </div>
        </>
      ),
      status: "finish",
    },
    {
      description: (
        <>
          <div className="stepsLayout">
            <p className="step">Step 2</p>
            <h4>
              <b>MCQ Test</b>
            </h4>
            <p className="Compleletd">Compleletd</p>
          </div>
        </>
      ),
      status: "finish",
    },
    {
      description: (
        <>
          <div className="stepsLayout">
            <p className="step">Step 3</p>
            <h4>
              <b>Protective Clothing</b>
            </h4>
            <p className="process">In Progress</p>
          </div>
        </>
      ),
      status: "process",
    },
    {
      description: (
        <>
          <div className="stepsLayout">
            <p className="step">Step 4</p>
            <h4>
              <b>Health Questionnaire</b>
            </h4>
            <p>Pending</p>
          </div>
        </>
      ),
      status: "wait",
    },
    {
      description: (
        <>
          <div className="stepsLayout">
            <p className="step">Step 5</p>
            <h4>
              <b>Registraion</b>
            </h4>
            <p>Pending</p>
          </div>
        </>
      ),
      status: "wait",
    },
  ];

  const customDot = (dot, { status }) => {
    switch (status) {
      case "finish":
        return <CheckCircleFilled />;
      case "process":
        return (
          <>
            <div className="circle-step">
              <div id="outer-circle">
                <div id="inner-circle"></div>
              </div>
            </div>
          </>
        );
      case "wait":
        return (
          <>
            <div className="circle-step">
              <div id="outer-circle">
                <div id="inner-circle"></div>
              </div>
            </div>
          </>
        );
      default:
        return dot;
    }
  };

  return (
    <>
      <div
        className="logo-title"
        style={{ boxShadow: "3px 3px 10px -4px rgba(0, 0, 0, 0.1)" }}
      >
        <img
          src="/assest/Images/Logo/logo.png"
          className="logo-png"
          style={{ width: "14%" }}
        />
      </div>
      <div className="container form-container pt-3">
        {contextHolder}
        <div className="row justify-content-center ">
          <div className="col-xl-10 col-lg-10 col-md-12 px-0">
            <Steps
              current={1}
              labelPlacement="vertical"
              items={items}
              progressDot={customDot}
            />
          </div>
          <Title className="sub-title text-center pt-5">
            Protective Clothing Form
          </Title>
          <div className="col-xl-9 col-lg-9 col-md-12 p-0  pb-5">
            <div className="card-body ">
              <>
                <div className="question-border ">
                  <Form
                    name="nest-messages"
                    layout="vertical"
                    onFinish={handleSubmit}
                  >
                    <>
                      <div className="Protective-Clothing">
                        <Form.Item
                          name="protectiveDate"
                          label="Date"
                          initialValue={currentDate}
                          className="text-lable col-lg-6 col-sm-12 col-md-7"
                        >
                          <DatePicker
                            type="date"
                            format="DD/MM/YYYY"
                            placeholder="DD/MM/YY"
                            className="form-control control-input"
                            disabled
                          />
                        </Form.Item>
                      </div>
                      <Form.Item
                        name="personName"
                        label="Name of the Person"
                        className="text-lable col-lg-6 col-sm-12 col-md-7"
                        rules={[
                          {
                            required: true,
                            message: "Please enter your first name.",
                          },
                          {
                            pattern: /^[A-Za-z\s]+$/,
                            message: "Only alphabet characters are allowed.",
                          },
                        ]}
                      >
                        <Input
                          type="text"
                          placeholder="Enter Name of the person"
                          className="form-control control-input"
                        />
                      </Form.Item>
                      <Form.Item
                        name="personRole"
                        label="Role of the Person"
                        className="text-lable col-lg-6 col-sm-12 col-md-7"
                        rules={[
                          {
                            required: true,
                            message: "Please enter your first name.",
                          },
                          {
                            pattern: /^[A-Za-z\s]+$/,
                            message: "Only alphabet characters are allowed.",
                          },
                        ]}
                      >
                        <Input
                          type="text"
                          placeholder="Enter Role of the person"
                          className="form-control control-input"
                        />
                      </Form.Item>

                      <Form.Item
                        name="guideline"
                        initialValue={`It is the Policy of the company that each staff member is responsible for washing their personal protective clothing e.g. white coats, aprons and hats. As the protective clothing is not laundered professionally it must be effectively controlled by each staff member to ensure garments are maintained in a good condition and do not present any risk of contamination. In this regard the following should be adhered to:

•	Wash the protective clothing garments separately from all other domestic washing.
•	Ensure the wash cycle reached a temperature >60degrees for your uniform.
•	Do not use any strongly scented washing powder that might taint food.
•	Once washed store the garments in an appropriate area (clean, dry, in an area free from contamination e.g. designated locker in store).

I have read and fully understand the home laundering procedure:`}
                        className="text-lable col-lg-12 col-sm-12 col-md-12 py-4"
                      >
                        <TextArea
                          readOnly
                          className="form-control control-input p-3"
                          rows={13}
                          style={{
                            resize: "none",
                            background: "#EEF3D8",
                            border: "1px solid #EEF3D8",
                          }}
                        ></TextArea>
                      </Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        className="btn btn-primary mt-2 btn-submit"
                      >
                        I Agree
                      </Button>
                    </>
                  </Form>
                </div>
              </>
            </div>
          </div>
        </div>
        <FooterRegistraion />
      </div>
    </>
  );
};

export default Protective;
